import { useEffect, useState } from "react";
import "./App.css";
// import { BrowserRouter as Router } from "react-router-dom";
import styled from "styled-components";
import Button from "./components/intro/Button";
import NextButton from "./components/intro/NextButton";
function App() {
  const [stage, setStage] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(true);
  // const [disableYes, setDisableYes] = useState(false);
  const [disableNo, setDisableNo] = useState(false);
  useEffect(() => {
    // Set a timeout to update the message after 2000 milliseconds (2 seconds)
    const timeoutId = setTimeout(() => {
      // setMessage('Timeout completed!');
      setLoaded((prev) => !prev);
    }, 2000);

    // Cleanup the timeout to avoid memory leaks
    return () => clearTimeout(timeoutId);
  }, []);
  useEffect(() => {
    if (loaded) {
      setLoading(false);
    }
  }, [loaded]);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      // setMessage('Timeout completed!');
      if (loading) setLoading(false);
    }, 500);

    // Cleanup the timeout to avoid memory leaks
    return () => clearTimeout(timeoutId);
  }, [loading]);
  return (
    // <App.Wrapper className=" w-screen h-screen bg-black p-4 flex flex-col justify-center items-center">
    <App.Wrapper className="  p-4 flex flex-col justify-between items-center">
      {loading && !loaded && (
        <img
          className="loader"
          alt="loader"
          src="https://gifdb.com/images/high/walking-bear-loading-walk-mjmobhdpwc1toy09.gif"
        />
      )}
      {loading && loaded && (
        <img
          className="loader"
          alt="loader"
          src="https://gifdb.com/images/high/walking-bear-loading-walk-mjmobhdpwc1toy09.gif"
        />
      )}
      {!loading && stage === 0 && (
        <div className="modal justify-center">
          <h1 className="text-2xl">Hi Baby,</h1>
          <img
            alt="i love you"
            src="https://gifdb.com/images/high/animated-cat-gif-file-2384kb-yl5va57ikcmp8wm7.webp"
          />
          <p className="sm:text-xl text-xl">
            It's another valentines again...
            {/*<b> I L🌸VE Y🌸U</b> ...*/}
          </p>
          <div className="w-full flex justify-center">
            <NextButton
              type="Next"
              title="Next"
              onClick={setStage}
              setLoading={setLoading}
            />
          </div>
        </div>
      )}
      {!loading && stage === 1 && (
        <div className="modal">
          <img alt="massage" src="https://gifdb.com/images/high/animated-cat-gif-file-973kb-665nqgxogekttqhr.webp" />
          <p className="sm:text-xl text-2xl monospace font-mono">
            And would love if...
          </p>
          <div className="w-full flex justify-center">
            <NextButton
              type="Prev"
              title="Prev"
              onClick={setStage}
              setLoading={setLoading}
            />
            <NextButton
              type="Next"
              title="Next"
              onClick={setStage}
              setLoading={setLoading}
            />
          </div>
        </div>
      )}
      {!loading && stage === 2 && (
        <div className="modal">
          <img
            alt="beyonce"
            src="https://gifdb.com/images/high/blow-kiss-beyonce-bath-ssu70hn3af3viixl.gif"
          />
          <p className="sm:text-xl text-2xl monospace font-mono">
            YOU could be...
          </p>
          <div className="w-full flex justify-center">
            <NextButton
              type="Prev"
              title="Prev"
              onClick={setStage}
              setLoading={setLoading}
            />
            <NextButton
              type="Next"
              title="Next"
              onClick={setStage}
              setLoading={setLoading}
            />
          </div>
        </div>
      )}
      {!loading && stage === 3 && (
        <div className="modal">
          <img src="https://gifdb.com/images/high/animated-cat-gif-file-898kb-vjnjoec6luyxgmul.webp" alt="again" />
          <p className="sm:text-xl text-2xl monospace font-mono">
            my valentines again... 🌸...
          </p>
          <div className="w-full flex justify-center">
            <NextButton
              type="Prev"
              title="Prev"
              onClick={setStage}
              setLoading={setLoading}
            />
            <NextButton
              type="Next"
              title="Next"
              onClick={setStage}
              setLoading={setLoading}
            />
          </div>
        </div>
      )}
      {!loading && stage === 4 && (
        <div className="modal">
          <img
            alt="hugs"
            src="https://gifdb.com/images/high/hugs-peach-and-goma-bears-sweet-couple-xcz0dbhqkpzgfqqr.gif"
          />
          <p className="sm:text-xl text-2xl monospace font-mono">
            I love your hugs 🌸...
          </p>
          <div className="w-full flex justify-center">
            <NextButton
              type="Prev"
              title="Prev"
              onClick={setStage}
              setLoading={setLoading}
            />
            <NextButton
              type="Next"
              title="Next"
              onClick={setStage}
              setLoading={setLoading}
            />
          </div>
        </div>
      )}
      {!loading && stage === 5 && (
        <div className="modal">
          <img
            alt="kisses"
            src="https://gifdb.com/images/high/animated-bear-kiss-enngnq0gm2r405bt.gif"
          />
          <p className="sm:text-xl text-2xl monospace font-mono">
            I love your kisses 🌸...
          </p>
          <div className="w-full flex justify-center">
            <NextButton
              type="Prev"
              title="Prev"
              onClick={setStage}
              setLoading={setLoading}
            />
            <NextButton
              type="Next"
              title="Next"
              onClick={setStage}
              setLoading={setLoading}
            />
          </div>
        </div>
      )}
      {!loading && stage === 1999 && (
        <div className="modal">
          <img
            alt="eating"
            src="https://gifdb.com/images/high/milk-bear-eating-fruits-lunch-time-499yai8griyrt3bz.gif"
          />
          <p className="sm:text-xl text-2xl monospace font-mono">
            Thank you for feeding me 🌸...
          </p>
          <div className="w-full flex justify-center">
            <NextButton
              type="Prev"
              title="Prev"
              onClick={setStage}
              setLoading={setLoading}
            />
            <NextButton
              type="Next"
              title="Next"
              onClick={setStage}
              setLoading={setLoading}
            />
          </div>
        </div>
      )}
            {!loading && stage === 6 && (
        <div className="modal">
          <img
            alt="bites"
            src="https://gifdb.com/images/high/hug-romantic-bear-couple-cuddle-7kjywjx7m9tsb3aq.gif"
          />
          <p className="sm:text-xl text-2xl monospace font-mono">
            I love your bites 🌸...
          </p>
          <div className="w-full flex justify-center">
            <NextButton
              type="Prev"
              title="Prev"
              onClick={setStage}
              setLoading={setLoading}
            />
            <NextButton
              type="Next"
              title="Next"
              onClick={setStage}
              setLoading={setLoading}
            />
          </div>
        </div>
      )}
            {!loading && stage === 7 && (
        <div className="modal">
          <img
            alt="cuddles"
            src="https://gifdb.com/images/high/kawaii-bears-cuddling-af14wxbtxgap35ly.gif"
          />
          <p className="sm:text-xl text-2xl monospace font-mono">
            I love your cuddles 🌸...
          </p>
          <div className="w-full flex justify-center">
            <NextButton
              type="Prev"
              title="Prev"
              onClick={setStage}
              setLoading={setLoading}
            />
            <NextButton
              type="Next"
              title="Next"
              onClick={setStage}
              setLoading={setLoading}
            />
          </div>
        </div>
      )}
      {!loading && stage === 8 && (
        <div className="modal">
          <p className="typewriter sm:text-xl text-2xl monospace font-mono w-fit">
            Sara-Joy Baby 🌸...
          </p>
          <div className="w-full flex justify-center">
            <NextButton
              type="Prev"
              title="Prev"
              onClick={setStage}
              setLoading={setLoading}
            />
            <NextButton
              type="Next"
              title="Next"
              onClick={setStage}
              setLoading={setLoading}
            />
          </div>
        </div>
      )}
      {!loading && stage === 9 && (
        <div className="modal">
          <div className="w-full h-10 ">
            <h1 className="typewriter text-pink-400 text-wrap text-center text-2xl ">
              🌸 Will You be my valentine?🌸
            </h1>
          </div>

          <div className="w-full flex flex-col justify-center items-center ">
            <img
              className=" "
              alt="teddy"
              src="https://gifdb.com/images/high/cute-love-bear-roses-ou7zho5oosxnpo6k.gif"
            />
          </div>
          <div className="button ">
            <Button title="NO" type="NO" />
            <Button title="YES" type="YES" setStage={setStage} stage={stage} setDisableNo={setDisableNo} disableNo={disableNo} />

          </div>
        </div>
      )}
      {!loading && stage === 10 && (
          <div className="modal mb-8">
            <div className="w-full h-10 ">
              <h1 className="typewriter text-pink-400 text-wrap text-center text-2xl ">Happy Valentines My Tomato Jos</h1>

              <div className="w-full flex flex-col justify-center items-center ">
                <img
                    className=" "
                    alt="teddy"
                    src="https://gifdb.com/images/high/kawaii-cat-mochi-kiss-e2ep2f9mk5hb5k20.webp"
                />
              </div>
            </div>

          </div>
      )}
      <div className="w-full mt-3">
        <iframe className="iframe-1"
                src="https://open.spotify.com/embed/track/6jG2YzhxptolDzLHTGLt7S?utm_source=generator" width="100%"
                height="352" allowFullScreen=""
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"></iframe>
      </div>

    </App.Wrapper>
  );
}

App.Wrapper = styled.div`
  height: 100vh;
  width: 100vw;
  margin: 0 auto;
  // background-color: pink;
  display: flex;

  .iframe-1{
  border-radius:12px
  }
  .loader {
    justify-self: center;
  }

  p {
    // font: bold 3rem monospace;
  }

  .modal {
    padding: 10px 2.5px;
    width: 500px;
    height: 500px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    img {
      width: 300px;
      height: 300px;
    }
     //background-color: pink;
  }
  .button {
    width: 100%;
    // background-color: orange;
    display: flex;
    justify-content: space-between;
  }
  @media screen and (max-width: 600px) {
    .modal {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
    }
  }
`;
export default App;
